/* eslint-disable @atlassian/i18n/no-literal-string-in-object */

// Note: Only English is supported for natural language search at this time.
// All query suggestions below are intentionally defined in English only.

// Google Drive
export const GOOGLE_DRIVE_STATIC_SUGGESTIONS: string[] = [
	'Show me my recent files',
	'Show me my recent Google docs',
	'List files I worked on recently',
	'Find files I edited this week',
	'Find Google docs I edited this week',
	'Google docs I worked on in the last 90 days',
	'Find files I updated in the last 7 days',
	'Show Google docs I worked on in the past year',
	'My newest Google docs',
	'My files older than 2 months',
	'Show my files from this year',
	'Google docs I updated in the last 14 days',
];

export const GOOGLE_DRIVE_DYNAMIC_SUGGESTIONS: Array<(query: string) => string> = [
	(query) => `Show files about "${query}"`,
	(query) => `Show Google docs about "${query}"`,
	(query) => `Find recent files related to "${query}"`,
	(query) => `Find recent Google docs related to "${query}"`,
	(query) => `List Google docs I worked on about "${query}"`,
	(query) => `Show "${query}" files from the last 90 days`,
	(query) => `Google docs related to "${query}"`,
	(query) => `"${query}" files I edited this week`,
	(query) => `"${query}" files`,
	(query) => `"${query}" Google docs`,
	(query) => `"${query}" files from this year`,
	(query) => `List my "${query}" files`,
];
